import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "../../../style/scss/layout/_notification.scss"
import { Chart } from "primereact/chart";
import { Calendar } from 'primereact/calendar';
import ProjectModals from "../../../core/modals/projectModal";
import RequestModals from "../../../core/modals/requestModal";
import TodoModal from "../../../core/modals/todoModal";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardAction, fetchLoggedInUser, fetchRecentActivityAction } from "../../../core/data/redux/actions/UserActions";
import { RootState } from "../../../core/data/redux/store";
import moment from "moment";
import TicketListModal from "../../../core/modals/ticketListModal";
import { auth_token } from "../../../core/data/redux/constants";
import { getGreeting, handleImageUpload } from "../../../core/data/utils";
import Loader from "../../Loader/Loader";
import { Logout } from "../../../core/data/redux/actions/AuthActions";

const AdminDashboard = () => {
  const PAGE_SIZE = 10;
  const dashboardData = useSelector((state: RootState) => state.user.dashboardData);
  const [recentActivity, setRecentActivity] = useState<any[]>([])

  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observerRef = useRef<HTMLDivElement | null>(null);
  const pageRef = useRef(0);
  const hasMoreRef = useRef(true);
  const loadingMoreRef = useRef(false);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const loadActivities = useCallback(async (pageNum: number, append: boolean) => {
    if (append && (!hasMoreRef.current || loadingMoreRef.current)) {
      return;
    }

    if (append) {
      loadingMoreRef.current = true;
      setLoadingMore(true);
    }

    try {
      const data = await dispatch(fetchRecentActivityAction(pageNum, PAGE_SIZE));
      const newItems = data?.content || [];
      const moreAvailable = data?.last === false && newItems.length === PAGE_SIZE;

      setRecentActivity((prev) => (append ? [...prev, ...newItems] : newItems));
      setHasMore(moreAvailable);
      hasMoreRef.current = moreAvailable;
      pageRef.current = pageNum + 1;
    } catch (error) {
      console.error("Error fetching activities:", error);
      setHasMore(false);
      hasMoreRef.current = false;
    } finally {
      if (append) {
        loadingMoreRef.current = false;
        setLoadingMore(false);
      } else {
        setInitialLoading(false);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const loadInitialData = async () => {
      setInitialLoading(true);
      await dispatch(fetchDashboardAction());
      await loadActivities(0, false);
    };
    loadInitialData();
  }, [dispatch, loadActivities]);

  useEffect(() => {
    const node = observerRef.current;
    if (!node || !hasMore) return;

    const scrollRoot = node.parentElement;

    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          hasMoreRef.current &&
          !loadingMoreRef.current &&
          !initialLoading
        ) {
          loadActivities(pageRef.current, true);
        }
      },
      { threshold: 0.1, root: scrollRoot }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, initialLoading, loadActivities]);

  const currentUser = useSelector((state: RootState) => state.user.currentUser);
  console.log(currentUser)
  const [image, setImage] = useState("assets/img/profiles/avatar-12.jpg");
  useEffect(() => {

    setImage(currentUser.imagePath ? `data:image/png;base64,${currentUser.imagePath}` : "assets/img/profiles/avatar-12.jpg")

  }, [currentUser])
  const routes = all_routes;

  const [isTodo, setIsTodo] = useState([false, false, false]);

  const [date, setDate] = useState(new Date());


  const [semidonutData, setSemidonutData] = useState({});
  const [semidonutOptions, setSemidonutOptions] = useState({});
  const toggleTodo = (index: number) => {
    setIsTodo((prevIsTodo) => {
      const newIsTodo = [...prevIsTodo];
      newIsTodo[index] = !newIsTodo[index];
      return newIsTodo;
    });
  };


  const capitalizeFirstLetter = (input: string) => {
    return input ? input.slice(0, 1).toUpperCase().concat(input.slice(1, input.length)) : "";
  }


  return (
    <>
      {initialLoading ?

        (<Loader />) : (
          <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
              <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                  <div className="my-auto mb-2">
                    <h2 className="mb-1">Organisation Dashboard</h2>
                    <nav>
                      <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                          <Link to={routes.adminDashboard}>
                            <i className="ti ti-smart-home" />
                          </Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                          Dashboard
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">

                    <div className="ms-2 head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>

                <div className="card border-0">
                  <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
                    <div className="d-flex align-items-center mb-3">
                      <span className="avatar avatar-xl flex-shrink-0">
                        <label
                          htmlFor="imageUpload"
                          className="avatar avatar-lg me-2 avatar-rounded"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={image}
                            alt="User Avatar"
                            className="img-fluid"
                          />
                        </label>
                        <input
                          type="file"
                          id="imageUpload"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={(e) => handleImageUpload(e, dispatch)}
                        />
                      </span>
                      <div className="ms-3">
                        <h3 className="mb-2">
                          {getGreeting()}, {currentUser?.name}
                          {/* <Link to="#" className="edit-icon">
                      <i className="ti ti-edit fs-14" />
                    </Link> */}
                        </h3>
                      </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap mb-1">

                      <Link
                        to="#"
                        className="btn btn-primary btn-md mb-2"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#add_ticket"
                      >
                        <i className="ti ti-square-rounded-plus me-1" />
                        Create Task
                      </Link>
                    </div>
                  </div>
                </div>
                {/* /Welcome Wrap */}
                <div className="row">
                  {/* Widget Info */}
                  <div className="col-xxl-8 d-flex">
                    <div className="row flex-fill">

                      <div className="col-md-4 d-flex flex-direction-column">
                        <div className="card flex-fill">
                          <div className="card-body d-flex text-center justify-content-center align-items-center">
                            <span className="avatar rounded-circle bg-pink mb-2 me-3 ">
                              <i className="ti ti-checklist fs-25" />
                            </span>
                            <div className="text-start">
                              <h6 className="fs-13 fw-medium text-default mb-1">
                                Completed Tasks
                              </h6>
                              <h3 className="mb-3">
                                {dashboardData.completed || 0}/{dashboardData.total || 0}{" "}
                                <span className="fs-12 fw-medium text-success">
                                  <i className="fa-solid fa-caret-up me-1" />
                                  {dashboardData.total && dashboardData.pending &&
                                    <>{((Math.abs((dashboardData.total - dashboardData.pending) / dashboardData.total)) * 100).toFixed(2)} %</> || 0}
                                </span>
                              </h3>
                              <Link to={all_routes.tickets} state={{ state: 'completed' }} className="link-default">
                                View All
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex text-center justify-content-center align-items-center">
                            <span className="avatar rounded-circle bg-danger mb-2 me-3">
                              <i className="ti ti-browser fs-25" />
                            </span>
                            <div className="text-start">
                              <h6 className="fs-13 fw-medium text-default mb-1">
                                Pending Tasks
                              </h6>
                              <h3 className="mb-3">
                                {dashboardData.pending || 0}/{dashboardData.total || 0}{" "}
                                <span className="fs-12 fw-medium text-danger">
                                  <i className="fa-solid fa-caret-up me-1" />
                                  {dashboardData.total && dashboardData.pending &&
                                    <>
                                      {((Math.abs(dashboardData.pending / dashboardData.total)) * 100).toFixed(2)} %
                                    </>
                                    || 0}
                                </span>
                              </h3>
                              <Link to={all_routes.tickets} state={{ state: 'pending' }} className="link-default">
                                View All
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex text-center justify-content-center align-items-center">
                            <span className="avatar rounded-circle bg-purple mb-2 me-3">
                              <i className="ti ti-moneybag fs-25" />
                            </span>
                            <div className="text-start">
                              <h6 className="fs-13 fw-medium text-default mb-1">
                                Overdue Tasks
                              </h6>
                              <h3 className="mb-3">
                                {dashboardData.overdue || 0}/{dashboardData.pending || 0}{" "}
                                <span className="fs-12 fw-medium text-danger">
                                  <i className="fa-solid fa-caret-up me-1" />
                                  {dashboardData.overdue && dashboardData.pending &&
                                    <>{((Math.abs(dashboardData.overdue / dashboardData.pending)) * 100).toFixed(2)} %</> || 0}
                                </span>
                              </h3>
                              <Link to={all_routes.tickets} state={{ state: 'overdue' }} className="link-default">
                                View All
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                {/* Total Employee */}
                <div className="row">

                </div>
                <div className="row">


                </div>
                <div className="row">

                </div>
                <div className="row">
                  {/* Recent Activities */}
                  <div className="col-xxl-4 col-xl-12 d-flex">
                    <div className="card flex-fill">
                      <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                        <h5 className="mb-2">Recent Activities</h5>
                        {/* <Link to="activity.html" className="btn btn-light btn-md mb-2">
                    View All
                  </Link> */}
                      </div>
                      <div className="card-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {recentActivity && <>
                          {recentActivity?.map((activity: any, index: number) => (<div className="recent-item" key={index}>
                            <div className="d-flex justify-content-between">
                              <div className="d-flex align-items-center w-100">
                                <Link to="#"
                                  className="avatar  flex-shrink-0"
                                >
                                  {activity.image ? <img
                                    src={`data:image/png;base64,${activity.image}`}
                                    className="rounded-circle"
                                    alt="img"
                                  /> : <ImageWithBasePath
                                    src="assets/img/users/user-38.jpg"
                                    className="rounded-circle"
                                    alt="img"
                                  />}
                                </Link>
                                <div className="ms-2 flex-fill">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6 className="fs-medium text-truncate">
                                      <Link to="#">{capitalizeFirstLetter(activity.actionTakenBy)}</Link>
                                    </h6>
                                    <p className="fs-13">{moment(activity.actionTakenAt).format("DD-MM-YYYY hh:mm:ss a")}</p>
                                  </div>
                                  <p className="fs-13">
                                    {activity.actionTaken.toLowerCase() == "created" ? (
                                      <>
                                        Created{" "}
                                        <Link
                                          to={`${routes.tasksdetails.replace(":taskId", activity.taskName)}`}
                                        >
                                          <strong className="text-blue">
                                            {capitalizeFirstLetter(activity.title)}
                                          </strong>
                                        </Link>
                                        {" "}
                                        and assigned to{" "}
                                        <strong className="text-success">
                                          {capitalizeFirstLetter(activity.assignedTo)}
                                        </strong>
                                      </>
                                    ) : activity.actionTaken.toLowerCase() == "status_change" ? (
                                      <>
                                        Changed status of{" "}
                                        <Link to={`${routes.tasksdetails.replace(":taskId", activity.taskName)}`}>
                                          <strong className="text-blue">
                                            {capitalizeFirstLetter(activity.title)}
                                          </strong>
                                        </Link>
                                        {" "}
                                        from{" "}
                                        <strong className="text-success">{activity.oldValue}</strong> to{" "}
                                        <strong>{activity.newValue}</strong>
                                      </>
                                    ) : activity.actionTaken.toLowerCase() == "comment" ? (
                                      <>
                                        Added comment{" "}
                                        <strong className="text-primary">{activity.newValue}</strong> to{" "}
                                        <Link to={`${routes.tasksdetails.replace(":taskId", activity.taskName)}`}>
                                          <strong className="text-blue">
                                            {capitalizeFirstLetter(activity.title)}
                                          </strong>
                                        </Link>
                                        .
                                      </>
                                    ) : activity.actionTaken.toLowerCase() == "file_upload" ? (
                                      <>
                                        Upload file to{" "}
                                        <Link to={`${routes.tasksdetails.replace(":taskId", activity.taskName)}`}>
                                          <strong className="text-blue">
                                            {capitalizeFirstLetter(activity.title)}
                                          </strong>
                                        </Link>
                                        .
                                      </>
                                    ) : activity.actionTaken.toLowerCase() == "assignee_change" ? (
                                      <>
                                        Assigned{" "}
                                        <Link to={`${routes.tasksdetails.replace(":taskId", activity.taskName)}`}>
                                          <strong className="text-blue">
                                            {capitalizeFirstLetter(activity.title)}
                                          </strong>
                                        </Link>
                                        {" "}
                                        from{" "}
                                        <strong className="text-success">{activity.oldValue}</strong> to{" "}
                                        <strong>{activity.newValue}</strong>.
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>))}
                        </>}

                        {hasMore && <div ref={observerRef} style={{ height: "20px", marginTop: "10px" }}></div>}
                        {loadingMore && <p className="text-center">Loading more activities...</p>}
                      </div>
                    </div>
                  </div>
                  {/* /Recent Activities */}
                </div>
              </div>
              <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                <p className="mb-0">2025 © HKCL.</p>
                <p>
                  Designed &amp; Developed By{" "}
                  <Link to="https://hkcl.in" target="_blank" className="text-primary">
                    HKCL
                  </Link>
                </p>
              </div>
            </div>
            {/* /Page Wrapper */}
            <ProjectModals />
            <RequestModals />
            <TicketListModal />
            <TodoModal />

          </>)}
    </>

  );
};

export default AdminDashboard;

